module.exports = __webpack_public_path__ + "static/4-74fdc00c5096796f10d9c2321201db82.jpg";